export interface TwoFactorAuthSetupFormProps {
  onClose: () => void;
  onInitialVerificationCodeSent: () => void;
  onVerificationCodeResent: () => void;
  onRecoveryCodesShown: () => void;
}

export enum TwoFactorAuthSetupStep {
  VerifyPhoneNumber = 'verify_phone_number',
  ConfirmVerificationCode = 'confirm_verifications_code',
  ShowRecoveryCodes = 'show_recovery_codes',
}

export interface ConfirmVerificationCodeValues {
  verificationCode: string;
}

export interface VerifyPhoneNumberValues {
  phoneNumber: string;
}

export type TwoFactorAuthSetupFormValues = VerifyPhoneNumberValues & ConfirmVerificationCodeValues;
